import Config from '@configs/Environments';
import { Api } from '@helpers/index';
import useAxios from 'axios-hooks';
import useMockServer from './useMockServer';

const path = Config.API_END_POINT + '/entry/abolition/list';

const localtest = {
    count: 0,
}
const getParams = (conditions: any | null) => {
    const params = {
        systemClass: conditions.systemClass,
        requestCategory: conditions.requestCategory || '',
        contactId: conditions.contactId || '',
        powerCustomerLocationNumber: conditions?.powerCustomerLocationNumber || '',
        abolitionRequestDateFrom: conditions?.abolitionRequestDate?.start || '',
        abolitionRequestDateTo: conditions?.abolitionRequestDate?.end || '',
        abolitionDesiredDateFrom: conditions?.abolitionDesiredDate?.start || '',
        abolitionDesiredDateTo: conditions?.abolitionDesiredDate?.end || '',
        supplyEndDateFrom: conditions?.supplyEndDate?.start || '',
        supplyEndDateTo: conditions?.supplyEndDate?.end || '',
        demolitionDateFrom: conditions?.demolitionDate?.start || '',
        demolitionDateTo: conditions?.demolitionDate?.end || '',
        acceptStatus: conditions.acceptStatus.join(','),
        responseStatus: '',
        timestamp: conditions.timestamp
    };
    if (useMockServer) {
        localtest.count += 1;
        // console.log('+++ local API count:' + localtest.count + ' +++');
        // console.log(params);
        return {
            systemClass: conditions.systemClass || 1,
            contactId: 1,
        };
    }
    return params;
}

const useAllListCount = (conditions: any | null): Function => {
    
    const params = getParams(conditions);
    const paramsString = Api.paramsString(params);

    const [{ data }] = useAxios(`${path}${paramsString}`);
    const count = data?.pageInformation?.allListCount;

    return count ?? 0;
};

const useAllListData = (conditions: any): any => {
    const params = getParams(conditions);
    const paramsString = Api.paramsString(params);
    const result: any = useAxios(`${path}${paramsString}`, { useCache: false });
    if (useMockServer) {
        const data = result[0].data?.list;
        const loading = result[0].loading;
        const error = result[0].error;
        return { data, loading, error };
    } else {
        const [{ data, loading, error }] = result;
        return { data, loading, error };
    }
};

const useCloseRequestList = {
    useAllListCount,
    useAllListData,
};

export default useCloseRequestList;